var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.423 10.716L9.567 3.56l2.802 2.807-7.145 7.158-2.801-2.808zm-1.415 3.895l.708-3.186 2.8 2.807-3.122.759a.32.32 0 0 1-.386-.38zm13.85-11.355a.489.489 0 0 1-.004.693l-.776.765.007.007-.953.924-2.802-2.807.34-.33c.004-.003.005-.01.01-.015l1.373-1.351a.498.498 0 0 1 .7.003l2.104 2.11z"}));
}

Pencil.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Pencil;

Pencil.default = Pencil;
